/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import PropTypes from "prop-types";
import React from "react";
import AsyncSelect from "react-select/async";
import { FormGroup, Label } from "reactstrap";
import ValidationService from "../../../../service/ValidationService";
import SubmitButton from "../../../layout/Form/SubmitButton";
import TextAreaField from "../../../layout/Form/TextAreaField";
import TextField from "../../../layout/Form/TextField";
import ModalCardBody from "../../../layout/Modal/ModalCardBody";
import ModalCardFooter from "../../../layout/Modal/ModalCardFooter";

const SendMessageMessageForm = ({
    form,
    step,
    deal,
    institution,
    validation,
    isValid,
    onChange,
    onChangeDeal,
    getDeals
}) => (
    <React.Fragment>
        <ModalCardBody>
            <TextField
                fieldName={"to_member"}
                label={"To member:"}
                value={institution.name}
                disabled={true}
            />
            {deal && (
                <TextField
                    fieldName={"related_deal"}
                    label={"Related deal:"}
                    value={deal.name}
                    disabled={true}
                />
            )}
            {!deal && (
                <FormGroup>
                    <Label for="sectors">Related deal (Optional):</Label>
                    <AsyncSelect
                        name={"related_deal"}
                        placeholder={"Search deals..."}
                        loadOptions={getDeals}
                        value={form.related_deal}
                        onChange={onChangeDeal}
                        // cache={false}
                    />
                </FormGroup>
            )}
            <TextAreaField
                fieldName={"message"}
                label={"Message:"}
                onChange={onChange}
                rows={5}
                validation={ValidationService.getFieldValidation(
                    validation,
                    "message"
                )}
                value={form.message}
            />
        </ModalCardBody>
        <ModalCardFooter>
            <SubmitButton
                disabled={!isValid}
                fieldName={"submit"}
                label={step === "ONE" ? "Next: Select Recipients" : "Send"}
                className={"float-right"}
            />
        </ModalCardFooter>
    </React.Fragment>
);

SendMessageMessageForm.propTypes = {
    form: PropTypes.object.isRequired,
    getDeals: PropTypes.func.isRequired,
    step: PropTypes.string.isRequired,
    institution: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    isValid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeDeal: PropTypes.func.isRequired,
    deal: PropTypes.object
};

export default SendMessageMessageForm;
